export default __webpack_public_path__ + "static/media/background.0d0ae27c.svg";